import { FETCH_LISTS as fetchLists } from "../../../../../graphql/query/List";
import { multiSelect } from "../../../../../components/Functional";
import * as SelectList from "../../../../../components/Functional/SelectList";
import { LIST_TYPES } from "../../../../../constants/listTypes";
import EditableListName from "../../../../../components/Functional/SelectList/EditableListName";

const ListNameLink = props => {
  const { id, label } = props || {};
  const currentParams = new URLSearchParams(window.location.search);
  const nextParams = new URLSearchParams({
    status: "imageSelectListWorking",
    imageListId: id,
  });
  const listId = currentParams.get("listId");
  const workingListId = currentParams.get("workingListId");

  if (listId) {
    nextParams.set("listId", listId);
  } else if (workingListId) {
    nextParams.set("workingListId", workingListId);
  }

  return (
    <EditableListName
      id={id}
      label={label}
      to={`/exhibition?${nextParams.toString()}`}
      typeId={LIST_TYPES.EXHIBITION_IMAGE_WORKING}
    />
  );
};

const Actions = props => {
  const { formik } = props || {};
  const actionProps = {
    ...props,
    ids: Object.keys(formik?.values?.selectedList?.ids || {})?.map(item =>
      parseInt(item.replace("_", "")),
    ),
    typeId: LIST_TYPES.EXHIBITION_IMAGE_WORKING,
  };

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.DeleteList {...actionProps} />
    </div>
  );
};

const tableProps = props => {
  const { formik } = props || {};

  const multiSelectProps = {
    formik,
    label: "Select List",
    name: "selectedList",
    keyName: "id",
  };

  const tableProps = {
    dataKey: "lists",
    headers: [
      multiSelect(multiSelectProps),
      {
        label: "List Name",
        name: "name",
        sortKey: "name",
        type: "custom",
        component: ListNameLink,
      },
      { label: "Instance Count", name: "itemsCount", type: "label" },
      { label: "Date / Time Last Updated", name: "updatedAt", type: "date" },
      {
        name: "action",
        type: "custom",
        component: props => (
          <SelectList.TableActions
            {...props}
            listKey={"imageListId"}
            preserveQueryKeys={["listId", "workingListId"]}
            statusKey={"imageSelectListWorking"}
            typeId={LIST_TYPES.EXHIBITION_IMAGE_WORKING}
          />
        ),
      },
    ],
    FETCH_QUERY: fetchLists(),
    variables: {
      typeId: LIST_TYPES.EXHIBITION_IMAGE_WORKING,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
